import type { Tier } from '@busy/api';

// Architecture decision #7 (SESSION_MEMORY): tier priority order is fixed.
// at-risk > vip > regular > new > active.
// The DB view `client_tier` computes this server-side; this constant is the
// single client-side mirror used by UI ordering and filter chip iteration.
export const TIER_PRIORITY: readonly Tier[] = ['at-risk', 'vip', 'regular', 'new', 'active'] as const;

export const TIER_LABELS: Record<Tier, string> = {
  'at-risk': 'At-Risk',
  vip: 'VIP',
  regular: 'Regular',
  new: 'New',
  active: 'Active',
};

// Tailwind class fragments for the unified tier badge. These match the demo's palette
// (SESSION_MEMORY > Visual / design system > Tier badge palette).
export const TIER_CLASSES: Record<Tier, { bg: string; text: string; ring?: string }> = {
  'at-risk': { bg: 'bg-red-100', text: 'text-red-600' },
  vip: { bg: 'bg-gold-500', text: 'text-navy-900', ring: 'shadow-[0_0_0_3px_rgba(212,169,66,0.18)]' },
  regular: { bg: 'bg-green-50', text: 'text-green-600' },
  new: { bg: 'bg-orange-100', text: 'text-orange-700' },
  active: { bg: 'bg-bg-alt', text: 'text-ink-500' },
};
